// extracted by mini-css-extract-plugin
export default {"AnswerItem":"AnswerItem_AnswerItem__FSZM+","success":"AnswerItem_success__30zY5","error":"AnswerItem_error__Xpaj2"};